import React, { useState, useEffect } from 'react';
import { Table, Row, Space, Button, Spin } from 'antd';
import { Link, RouteComponentProps } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEcole } from '../ecole/ecole.reducer';
import { overridePaginationStateWithQueryParams } from 'app/shared/util/entity-utils';
import { getSortState, JhiItemCount, JhiPagination, TextFormat } from 'react-jhipster';
import { ITEMS_PER_PAGE } from 'app/shared/util/pagination.constants';
import { getDestinataires } from '../notification/destinataire.reducer';
import { APP_TIMESTAMP_FORMAT } from 'app/config/constants';
import { useCheckIsAnneeInactive } from 'app/hooks/useCheckIsAnneeActive';

const Notification = (props: RouteComponentProps<{ ecoleid: string; anneeScolaireId: string }>) => {
  const { match } = props;
  const dispatch = useAppDispatch();

  const [paginationState, setPaginationState] = useState(
    overridePaginationStateWithQueryParams(getSortState(props.location, ITEMS_PER_PAGE, 'id'), props.location.search)
  );
  const totalItems = useAppSelector(state => state.destinataire.totalItems);
  const currentEcole = useAppSelector(state => state.ecole.entity);
  const loading = useAppSelector(state => state.notification.loading);
  const notificationList = useAppSelector(state => state.notification.entities);
  const destinataires = useAppSelector(state => state.destinataire.entities);
  const inactiveAnnee = useCheckIsAnneeInactive(props.match.params.anneeScolaireId);

  useEffect(() => {
    dispatch(getEcole(props.match.params.ecoleid));
    sortEntities();
  }, [paginationState.activePage, paginationState.order, paginationState.sort]);

  const notifications = () => {
    const entity = {
      ecoleId: props.match.params.ecoleid,
      anneeScolaireId: props.match.params.anneeScolaireId,
      page: paginationState.activePage - 1,
      size: paginationState.itemsPerPage,
    };
    dispatch(getDestinataires(entity));
  };
  const sortEntities = () => {
    notifications();
    const endURL = `?page=${paginationState.activePage}&sort=${paginationState.sort},${paginationState.order}`;
    if (props.location.search !== endURL) {
      props.history.push(`${props.location.pathname}`);
    }
  };

  useEffect(() => {
    const params = new URLSearchParams(props.location.search);
    const page = params.get('page');
    if (page) {
      setPaginationState({
        ...paginationState,
        activePage: +page,
      });
    }
  }, [props.location.search]);
  const handlePagination = currentPage =>
    setPaginationState({
      ...paginationState,
      activePage: currentPage,
    });
  const columns = [
    {
      title: 'Destinataires',
      dataIndex: 'parent',
      key: 'parent',
    },
    {
      title: 'Contenu du Message',
      dataIndex: 'message',
      key: 'message',
    },
    {
      title: 'Date/Heures',
      dataIndex: 'date',
      key: 'date',
      render: date => <TextFormat type="date" value={date} format={APP_TIMESTAMP_FORMAT} />,
    },
    {
      title: 'Option',
      dataIndex: 'id',
      key: 'id',
      render: id => (
        <Space size="middle">
          <Button type="primary" style={{ height: 30, width: 45 }}>
            <Link to={`/notification/${currentEcole && currentEcole.id}/${props.match.params.anneeScolaireId}/${id}/details`}>
              <FontAwesomeIcon icon="eye" />{' '}
            </Link>
          </Button>
        </Space>
      ),
    },
  ];
  const data = destinataires?.map(d => ({
    id: d.id,
    parent: d.eleveMatricule
      ? 'Parent de l&apos;élève avec le matricule ' + d.eleveMatricule
      : 'Tous les parents ' +
        (d.etatPaiement ? d.etatPaiement + ' ' : '') +
        (d.statutPresence ? d.statutPresence + ' ' : '') +
        (d.classes && d.classes.length > 0
          ? d.classes.length === 1
            ? ' de la classe de ' + d.classes[0].nom
            : ' des classes ' + d.classes.map(c => c.nom).join(', ')
          : ''),
    message: d.message ? d.message.slice(0, 200) + '...' : '<vide>',
    date: d.createdDate,
  }));

  return (
    <div>
      <h3>Messages</h3>
      <Row className="justify-content-end p-2">
        <Link
          to={`${match.url}/new`}
          className={`btn ${inactiveAnnee && 'disabled'}`}
          id="jh-create-entity"
          style={{
            background: inactiveAnnee ? '#ccc' : '#F28E19',
            color: 'white',
            border: `1px solid ${inactiveAnnee ? '#ccc' : '#F28E19'}`,
          }}
          data-cy="entityCreateButton"
        >
          <FontAwesomeIcon icon="plus" />
          &nbsp; Nouveau message
        </Link>
      </Row>
      <div className="table-responsive">
        <Spin spinning={loading} tip="Chargement...">
          <Table style={{ textAlign: 'center' }} columns={columns} dataSource={data} pagination={false} />
        </Spin>
      </div>
      {totalItems ? (
        <div className={destinataires && destinataires.length > 0 ? 'table-responsive' : 'd-none'}>
          <Row className="justify-content-center">
            <JhiItemCount page={paginationState.activePage} total={totalItems} itemsPerPage={paginationState.itemsPerPage} i18nEnabled />
          </Row>
          <Row className="justify-content-center">
            <JhiPagination
              activePage={paginationState.activePage}
              onSelect={handlePagination}
              maxButtons={5}
              itemsPerPage={paginationState.itemsPerPage}
              totalItems={totalItems}
            />
          </Row>
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default Notification;
